import React from 'react'

import Navigation from './../../landing/components/Nav'
import FaqComponent from './../../landing/components/Faq'
import Footer from './../../landing/components/Footer'


const Faq = props => {
	return (
		<>
			<Navigation />
			<FaqComponent />
			<Footer />
		</>
	)
}

export default Faq